var _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoLkMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 67,
    viewBox: "0 0 68 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1490_3723)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0051 39.477L17.8745 35.6468L14.0051 31.816C15.6221 34.1109 15.6221 37.182 14.0051 39.477Z",
    fill: "#70C1D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1492 27.7915L22.0185 31.6217L18.1492 35.4519C19.7661 33.1569 19.7661 30.0859 18.1492 27.7909V27.7915Z",
    fill: "#70C1D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0051 23.7676L17.8745 27.5978L14.0051 31.4286C15.6221 29.133 15.6221 26.0625 14.0051 23.7676Z",
    fill: "#70C1D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0438 46.2184L44.7865 44.3387L44.1144 45.0658V46.2184H43.2056V41.844H44.1144V43.9271C44.1144 43.9271 44.444 43.5875 45.9136 41.844H47.0963L45.4158 43.6613L47.1648 46.2184H46.0445H46.0438Z",
    fill: "#70C1D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1328 44.857C48.1946 45.3007 48.4814 45.541 48.923 45.541C49.1909 45.541 49.4459 45.4236 49.5517 45.1899H50.4415C50.2489 45.8431 49.6507 46.2929 48.8979 46.2929C47.9335 46.2929 47.2546 45.5901 47.2546 44.5985C47.2546 43.6069 47.9267 42.9161 48.8918 42.9161C49.8568 42.9161 50.51 43.6432 50.51 44.5985C50.51 44.7401 50.4978 44.8576 50.4978 44.8576H48.1322L48.1328 44.857ZM48.1451 44.228H49.6269C49.5645 43.8648 49.2967 43.6184 48.8863 43.6184C48.4759 43.6184 48.2197 43.8587 48.1451 44.228Z",
    fill: "#70C1D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8579 46.1627L50.5693 42.9894H51.5093L52.2939 45.1463L53.0847 42.9894H54.0057L52.182 47.5H51.3106L51.8585 46.1627H51.8579Z",
    fill: "#70C1D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9421 39.207V23.7676H28.8948V39.207H25.9421Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2886 25.2701C31.2886 24.241 32.0371 23.5 33.0774 23.5C34.1177 23.5 34.8656 24.241 34.8656 25.2701C34.8656 26.2992 34.1171 27.0202 33.0774 27.0202C32.0377 27.0202 31.2886 26.2992 31.2886 25.2701Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5537 28.4199H31.6011V39.207H34.5537V28.4199Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3144 28.4199V30.7257H40.6302V39.2076H37.6769V30.7251H36.1174V28.4193H37.6769V27.5554C37.6769 24.9614 39.174 23.767 41.3787 23.767C41.8986 23.767 42.2526 23.8081 42.2526 23.8081V26.3198C42.2526 26.3198 42.1273 26.2986 41.7946 26.2986C41.0876 26.2986 40.6302 26.5868 40.6302 27.493V28.4193H42.3144V28.4199Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0609 34.6576C46.2694 36.1396 47.2259 36.9423 48.7022 36.9423C49.5963 36.9423 50.4488 36.5506 50.8029 35.7691H53.7764C53.1318 37.9514 51.1356 39.454 48.619 39.454C45.3949 39.454 43.1284 37.1075 43.1284 33.7925C43.1284 30.4775 45.3747 28.1722 48.5983 28.1722C51.8218 28.1722 54.0051 30.6022 54.0051 33.7925C54.0051 34.2659 53.9635 34.6576 53.9635 34.6576H46.0609ZM46.1025 32.5576H51.0519C50.8445 31.3432 49.9504 30.5199 48.5768 30.5199C47.2033 30.5199 46.352 31.3226 46.1018 32.5576H46.1025Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1490_3723"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 24,
    fill: "white",
    transform: "translate(14.0051 23.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLkMenu);
export default __webpack_public_path__ + "static/media/Logo_LK_Menu.138a349b2dbba22c2b91c528e3faaafd.svg";
export { ForwardRef as ReactComponent };